import { ObKeyValString } from "type/common/common.type";

export const TOPIC_PER_PAGE_MAX = 5;

export const TOPIC_STATISTIC_TYPE: ObKeyValString = {
  ANSWER_PLAY: "answer_play",
  RELATE_PLAY: "relate_play",
  NONE: "",
};

export const TOPIC_STATISTIC_TYPES = Object.values(TOPIC_STATISTIC_TYPE);

export const INPUT_TYPE_TEXT = "inputTypeText";

export const INPUT_TYPE_TEXT_FIELD = {
  CONTENT: "content",
  TRANSLATION: "translation",
};
